import type { I18n } from '@change-corgi/core/i18n';
import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { PetitionDetailsPagePrefetchedContext } from '#src/app/pages/petitionDetails/pageContext';
import type { Sharer } from '#src/app/pages/petitionDetails/shared/types';
import { headlineReplacements } from '#src/app/pages/petitionDetails/shared/utils';
import type { LoadedStateData } from '#src/app/shared/utils/async';

import type { ShareHeadlineOverrides } from './types';

/**
 * The sharer-name title of `/fbog` links. Undefined without a sharer, so the page keeps the default title.
 */
export function facebookSharerHeadline({
	pageData,
	sharer,
	i18n,
}: {
	pageData: LoadedStateData<PetitionDetailsPagePrefetchedContext['pageData']>['pageData'];
	sharer: Sharer | undefined;
	i18n: I18n | UtilityContext['i18n'];
}): ShareHeadlineOverrides | undefined {
	if (!sharer) return undefined;
	const replacements = headlineReplacements({ pageData, sharer });
	return {
		title: i18n.translate('fe.components.petition_share.share_text_fb', replacements),
		description: replacements.petition_name as string,
	};
}
